module.exports = __webpack_public_path__ + "static/img/menu-product-e10.2f7316cc.png";